import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import ServerFormErrors from "../../util/ServerFormErrors";
import ax from "../../util/axios";
import { add_submit_overlay, remove_submit_overlay } from "../../util/submit_overlay";
import { useIntl } from "react-intl";

const AssignOrganisationForm = (props) => {
  const intl = useIntl();
  const [errorMessage, setErrorMessages] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: {} });
  const onSubmit = (data) => {
    add_submit_overlay();
    ax({
      method: "POST",
      url: props.url,
      data: { form: data },
    })
      .then(function () {
        window.location = window.location.href;
      })
      .catch((err) => {
        setErrorMessages(err.response.data);
        remove_submit_overlay();
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label>{intl.formatMessage({ id: "units.organisation-field" })}</label>
          <select autoFocus className="form-control" {...register("organisation_id", { required: true })}>
            <option key="0" value="">
              {intl.formatMessage({ id: "shared.dropdown.please-select" })}
            </option>
            {props.organisations.map((org) => {
              return (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              );
            })}
          </select>
          {errors.organisation_id?.type === "required" && (
            <div className="field-error">{intl.formatMessage({ id: "shared.forms.required" })}</div>
          )}
        </div>

        <button type="submit" className="btn btn-primary small angled-bottom-right">
          {intl.formatMessage({ id: "shared.forms.save" })}
        </button>
      </form>

      <ServerFormErrors errorMessages={errorMessage}></ServerFormErrors>
    </div>
  );
};

AssignOrganisationForm.propTypes = {
  url: PropTypes.string.isRequired,
  organisations: PropTypes.arrays,
};

export default AssignOrganisationForm;
